import { ContentLayoutComponent } from './content-layout/content-layout.component';
import { HeaderLayoutComponent } from './header-layout/header-layout.component';
import { FooterLayoutComponent } from './footer-layout/footer-layout.component';


export const layoutComponents = [
    ContentLayoutComponent,
    HeaderLayoutComponent,
    FooterLayoutComponent
];

export { ContentLayoutComponent } from './content-layout/content-layout.component';
export { HeaderLayoutComponent } from './header-layout/header-layout.component';
export { FooterLayoutComponent } from './footer-layout/footer-layout.component';